const onRowDelete = async (oldData) => {
  console.log('spoSched onRowDelete')
}

export default onRowDelete
